var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 2.17383V12.5002C26.5 13.9003 26.5 14.6004 26.7725 15.1352C27.0122 15.6056 27.3946 15.988 27.865 16.2277C28.3998 16.5002 29.0999 16.5002 30.5 16.5002H40.8263M31.5 42.75L27.75 39M26.5 1.5H13.5C9.29961 1.5 7.19941 1.5 5.59507 2.31745C4.18386 3.0365 3.0365 4.18386 2.31745 5.59507C1.5 7.19941 1.5 9.29961 1.5 13.5V39.5C1.5 43.7004 1.5 45.8006 2.31745 47.4049C3.0365 48.8161 4.18386 49.9635 5.59507 50.6825C7.19941 51.5 9.29961 51.5 13.5 51.5H29.5C33.7004 51.5 35.8006 51.5 37.4049 50.6825C38.8161 49.9635 39.9635 48.8161 40.6825 47.4049C41.5 45.8006 41.5 43.7004 41.5 39.5V16.5L26.5 1.5ZM30.25 32.75C30.25 37.5825 26.3325 41.5 21.5 41.5C16.6675 41.5 12.75 37.5825 12.75 32.75C12.75 27.9175 16.6675 24 21.5 24C26.3325 24 30.25 27.9175 30.25 32.75Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f7f16128e6d75d7353b5e19a4efcb156.svg";
export { ForwardRef as ReactComponent };